import { userPermissionsSelector } from 'app/auth/store/user.selector';
import { isFeatureAllowed } from 'app/auth/utils/utils';
import { AppDispatch } from 'app/store';
import { clearNavigationBadge, setNavigationBadge } from 'app/store/fuse/navigationBadgesSlice';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { currentStoreIdSelector } from '../../../stores/ducks/stores.selector';
import { VISIBILITY_BADGE_NAV_IDS, VISIBILITY_FEATURE } from '../../constants';
import {
  hasScoreLoadedSelector,
  hasUnansweredCountLoadedSelector,
  hasVisibilityLinkErrorSelector,
  hasVisibilityLinkLoadedSelector,
  isVisibilityLinkLoadingSelector,
  isVisibilityReadySelector,
  navigationBadgeCountsSelector,
} from '../../ducks/visibility.selector';
import { fetchScoreThunk, fetchUnansweredCountThunk, fetchVisibilityLinkThunk } from '../../ducks/visibility.thunk';
import { visibilityPalette } from '../../theme/visibility.palette';

const VisibilityNavBadge = () => {
  const dispatch = useDispatch<AppDispatch>();

  const permissions = useSelector(userPermissionsSelector);
  const currentStoreId = useSelector(currentStoreIdSelector);
  const isLoading = useSelector(isVisibilityLinkLoadingSelector);
  const hasLoaded = useSelector(hasVisibilityLinkLoadedSelector);
  const hasError = useSelector(hasVisibilityLinkErrorSelector);
  const isReady = useSelector(isVisibilityReadySelector);
  const hasCountLoaded = useSelector(hasUnansweredCountLoadedSelector);
  const hasScoreLoaded = useSelector(hasScoreLoadedSelector);
  const badgeCounts = useSelector(navigationBadgeCountsSelector);

  const isEnabled =
    Boolean(currentStoreId) && (!VISIBILITY_FEATURE || isFeatureAllowed(VISIBILITY_FEATURE, permissions));

  useEffect(() => {
    if (isEnabled && !hasLoaded && !isLoading) dispatch(fetchVisibilityLinkThunk());
  }, [dispatch, isEnabled, hasLoaded, isLoading]);

  useEffect(() => {
    if (isEnabled && isReady && !hasCountLoaded) dispatch(fetchUnansweredCountThunk());
  }, [dispatch, isEnabled, isReady, hasCountLoaded]);

  useEffect(() => {
    if (isEnabled && isReady && !hasScoreLoaded) dispatch(fetchScoreThunk());
  }, [dispatch, isEnabled, isReady, hasScoreLoaded]);

  useEffect(() => {
    VISIBILITY_BADGE_NAV_IDS.forEach(id => {
      const count = badgeCounts[id] ?? 0;
      const shouldShow = isEnabled && !hasError && count > 0;
      const badge = { title: String(count), bg: visibilityPalette.crit, fg: '#FFFFFF' };

      dispatch(shouldShow ? setNavigationBadge({ id, badge }) : clearNavigationBadge(id));
    });
  }, [dispatch, isEnabled, hasError, badgeCounts]);

  return null;
};

export default VisibilityNavBadge;
